export default "<div [ngClass]=\"className\" style=\"padding: 0;\">\r\n\t<ng-content></ng-content>\r\n</div>\r\n"